export type AcaoDeEsteira = 'approve' | 'execute' | 'validate' | 'signoff' | 'promote'

/**
 * As ações da esteira de ambientes para o status de hoje. Saíram do cartão da cadeia para a
 * faixa Próximo passo (spec 2026-10-21 §3.4) sem mudar a regra; quem recusa é o backend (403
 * de segregação), então não há gate de permissão aqui.
 */
export function acoesDaEsteira(
  chamado: { status: string; request_type: string },
  ambiente: string | null | undefined,
): { label: string; act: AcaoDeEsteira }[] {
  switch (chamado.status) {
    case 'pending_approval':
      return [{ label: 'Aprovar solicitação', act: 'approve' }]
    case 'approved':
      return [{ label: 'Registrar execução', act: 'execute' }]
    case 'in_triage':
      // Direto da triagem, só incidente ou dev: mudança fora de dev passa pela
      // aprovação (consoleai#24955; o backend recusa do mesmo jeito).
      if (chamado.request_type === 'incident' || ambiente === 'dev') {
        return [{ label: 'Registrar execução', act: 'execute' }]
      }
      return [{ label: 'Aprovar solicitação', act: 'approve' }]
    case 'pending_validation':
      return [{ label: 'Validar execução', act: 'validate' }]
    case 'pending_signoff':
      return [{ label: 'Aprovar execução', act: 'signoff' }]
    case 'ready_to_promote':
      return [{ label: 'Promover', act: 'promote' }]
    case 'in_progress':
      return ambiente === 'dev' ? [{ label: 'Promover', act: 'promote' }] : []
    default:
      return []
  }
}
